import './App.css';
import GlobalRouter from "./routes/GlobalRouter";

function App() {
  return (
      <GlobalRouter></GlobalRouter>
  );
}

export default App;
